import PublicRouteService from '@services/public-route.service';

export const usePublicRouteService = () => {
  return new PublicRouteService();
};
